// import React, { useState, useEffect } from "react";
// import Table from "react-bootstrap/Table";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { useNavigate } from "react-router-dom";
// import "./ApplicationManagement.css";
// import NavigationBar from "../../Components/NavigationBar";

// export default function ShortlistApplications() {
//   const [showModal, setShowModal] = useState(false);
//   const [applications, setApplications] = useState([]);
//   const [currentAppID, setCurrentAppID] = useState(null);
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//   const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

//   // Fetch applications from the backend
//   useEffect(() => {
//     fetch(`${API_BASE_URL}/getShortlistedSubmittedApplications`)
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Fetched Data:", data); // Log the API response
//         if (Array.isArray(data)) {
//           setApplications(data);
//         } else {
//           console.error("API did not return an array:", data);
//         }
//       })
//       .catch((error) => console.error("Error fetching applications:", error));
//   }, []);

//   // Handle the click event for the "Shortlisted" or "Rejected" button
//   const handleClick = (app_ID, status) => {
//     fetch(`${API_BASE_URL}/updateApplicationStatus`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ applicationId: app_ID, status }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         alert(`Application ID: ${app_ID} has been ${status}`);
//         setApplications((prevApplications) =>
//           prevApplications.map((app) =>
//             app.Application_Id === app_ID ? { ...app, Status: status } : app
//           )
//         );
//       })
//       .catch((error) =>
//         console.error("Error updating application status:", error)
//       );
//   };

//   // Open modal to choose shortlist/rejection
//   const handleOpenModal = (app_ID) => {
//     setCurrentAppID(app_ID);
//     setShowModal(true);
//   };

//   // Close the modal
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setCurrentAppID(null);
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <h1 className="page-name">Evaluate and Shortlist Applications</h1>
//       <Table
//         striped
//         bordered
//         hover
//         style={{
//           marginTop: "20px",
//           boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//         }}
//       >
//         <thead>
//           <tr>
//             <th>Applicant Name</th>
//             <th>Application Id</th>
//             <th>Award Type</th>
//             <th>Submitted Date</th>
//             <th>Status</th>
//             <th>Action</th>
//             <th>Application</th>
//           </tr>
//         </thead>
//         <tbody>
//           {/* Display applications */}
//           {Array.isArray(applications) &&
//             applications.map((app) => (
//               <tr key={app.Application_Id}>
//                 <td>{app.Name}</td>
//                 <td>{app.Application_Id}</td>
//                 <td>{app.Award_Type}</td>
//                 <td>{app.SubmittedDate}</td>
//                 <td>{app.Status}</td>

//                 <td>
//                   {app.Status === "Shortlisted" || app.Status === "Rejected" ? (
//                     <button
//                       className={
//                         app.Status === "Shortlisted"
//                           ? "Shortlisted-button"
//                           : "Reject-button"
//                       }
//                       disabled
//                     >
//                       {app.Status}
//                     </button>
//                   ) : (
//                     <button
//                       className="select-unselect-button"
//                       onClick={() => handleOpenModal(app.Application_Id)}
//                     >
//                       Select
//                     </button>
//                   )}
//                 </td>

//                 <td>
//                   <button
//                     className="View_Button"
//                     onClick={() => {
//                       const formattedAwardType = app.Award_Type.replace(
//                         /\s+/g,
//                         "_"
//                       );
//                       const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
//                       const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
//                       window.open(fileUrl, "_blank"); // ✅ Open in a new tab
//                     }}
//                   >
//                     View
//                   </button>
//                 </td>
//               </tr>
//             ))}
//         </tbody>
//       </Table>

//       {/* Modal for selecting shortlist or rejection */}
//       <Modal show={showModal} onHide={handleCloseModal}>
//         <Modal.Header closeButton>
//           <Modal.Title className="modaltitle">
//             Select Application Status
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Button
//             variant="success"
//             className="granted_deny"
//             onClick={() => {
//               handleClick(currentAppID, "Shortlisted");
//               handleCloseModal();
//             }}
//           >
//             Shortlist
//           </Button>
//           <Button
//             variant="danger"
//             className="granted_deny"
//             onClick={() => {
//               handleClick(currentAppID, "Rejected");
//               handleCloseModal();
//             }}
//           >
//             Reject
//           </Button>
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import "./ApplicationManagement.css";
import NavigationBar from "../../Components/NavigationBar";

export default function ShortlistApplications() {
  const [showModal, setShowModal] = useState(false);
  const [applications, setApplications] = useState([]);
  const [awards, setAwards] = useState([]);
  const [selectedAward, setSelectedAward] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [currentAppID, setCurrentAppID] = useState(null);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

  // Define the awards to include (by Award_Id)
  const allowedAwardIds = [1, 4, 5]; 

  // Fetch applications and awards from the backend
  useEffect(() => {
    // Fetch applications
    fetch(`${API_BASE_URL}/getShortlistedSubmittedApplications`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Applications:", data);
        if (Array.isArray(data)) {
          setApplications(data);
        } else {
          console.error("API did not return an array for applications:", data);
        }
      })
      .catch((error) => console.error("Error fetching applications:", error));

    // Fetch awards
    fetch(`${API_BASE_URL}/getAwards`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Awards:", data);
        if (Array.isArray(data)) {
          // Filter awards to include only the allowed ones
          const filteredAwards = data.filter((award) =>
            allowedAwardIds.includes(award.Award_Id)
          );
          setAwards(filteredAwards);
        } else {
          console.error("API did not return an array for awards:", data);
        }
      })
      .catch((error) => console.error("Error fetching awards:", error));
  }, [API_BASE_URL]);

  // Generate years up to current year
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2024 + 1 },
    (_, i) => 2024 + i
  );

  // Filter applications based on selected award and year
  const filteredApplications = applications.filter((app) => {
    const matchesAward = selectedAward ? app.Award_Type === selectedAward : true;
    const matchesYear = selectedYear
      ? new Date(app.SubmittedDate).getFullYear().toString() === selectedYear
      : true;
    return matchesAward && matchesYear;
  });

  // Handle the click event for the "Shortlisted" or "Rejected" button
  const handleClick = (app_ID, status) => {
    fetch(`${API_BASE_URL}/updateApplicationStatus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ applicationId: app_ID, status }),
    })
      .then((response) => response.json())
      .then((data) => {
        alert(`Application ID: ${app_ID} has been ${status}`);
        setApplications((prevApplications) =>
          prevApplications.map((app) =>
            app.Application_Id === app_ID ? { ...app, Status: status } : app
          )
        );
      })
      .catch((error) =>
        console.error("Error updating application status:", error)
      );
  };

  // Open modal to choose shortlist/rejection
  const handleOpenModal = (app_ID) => {
    setCurrentAppID(app_ID);
    setShowModal(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentAppID(null);
  };

  return (
    <div>
      <NavigationBar />
      <h1 className="page-name">Evaluate and Shortlist Applications</h1>
      <div style={{ margin: "20px 0", display: "flex", gap: "20px" }}>
        <div>
          <label htmlFor="awardFilter">Filter by Award: </label>
          <select
            id="awardFilter"
            value={selectedAward}
            onChange={(e) => setSelectedAward(e.target.value)}
            style={{
              padding: "5px",
              marginLeft: "10px",
              minWidth: "200px",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
            }}
          >
            <option value="">All Awards</option>
            {awards.length > 0 ? (
              awards.map((award) => (
                <option key={award.Award_Id} value={award.Name}>
                  {award.Name || "Unnamed Award"}
                </option>
              ))
            ) : (
              <option disabled>No awards available</option>
            )}
          </select>
        </div>
        <div>
          <label htmlFor="yearFilter">Filter by Year: </label>
          <select
            id="yearFilter"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            style={{
              padding: "5px",
              marginLeft: "10px",
              minWidth: "100px",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
            }}
          >
            <option value="">Select Year</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
      <Table
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>Applicant Name</th>
            <th>Application Id</th>
            <th>Award Type</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>Action</th>
            <th>Application</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(filteredApplications) &&
            filteredApplications.map((app) => (
              <tr key={app.Application_Id}>
                <td>{app.Name}</td>
                <td>{app.Application_Id}</td>
                <td>{app.Award_Type}</td>
                <td>{app.SubmittedDate}</td>
                <td>{app.Status}</td>
                <td>
                  {app.Status === "Shortlisted" || app.Status === "Rejected" ? (
                    <button
                      className={
                        app.Status === "Shortlisted"
                          ? "Shortlisted-button"
                          : "Reject-button"
                      }
                      disabled
                    >
                      {app.Status}
                    </button>
                  ) : (
                    <button
                      className="select-unselect-button"
                      onClick={() => handleOpenModal(app.Application_Id)}
                    >
                      Select
                    </button>
                  )}
                </td>
                <td>
                  <button
                    className="View_Button"
                    onClick={() => {
                      const formattedAwardType = app.Award_Type.replace(
                        /\s+/g,
                        "_"
                      );
                      const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
                      const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title className="modaltitle">
            Select Application Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            variant="success"
            className="granted_deny"
            onClick={() => {
              handleClick(currentAppID, "Shortlisted");
              handleCloseModal();
            }}
          >
            Shortlist
          </Button>
          <Button
            variant="danger"
            className="granted_deny"
            onClick={() => {
              handleClick(currentAppID, "Rejected");
              handleCloseModal();
            }}
          >
            Reject
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
}